// extracted by mini-css-extract-plugin
module.exports = {"pnActiveLicense":"OrderActivations_pnActiveLicense__1XYOr","pnLicense":"OrderActivations_pnLicense__QOuLE","activate":"OrderActivations_activate__2UO3a"};